import { c as _c } from "react/compiler-runtime";
import { TextLink } from '@petsmart-ui/sparky';
import { type CSSProperties, type MouseEvent, useId } from 'react';
import { trackNavigationHeaderClick, useServicesLinkClick } from '../../../../../../shared';
import type { NavigationGroupModel } from '../../../../../../types';
import { resolveColumnCount } from './links-columns.utils';
import './links-columns.scss';
type LinksColumnsProps = {
  columns: NavigationGroupModel[][];
  desktopColumnCount?: number;
  selectionPath: string[];
};
export function LinksColumns(t0) {
  const $ = _c(7);
  const {
    columns,
    desktopColumnCount,
    selectionPath
  } = t0;
  let t1;
  if ($[0] !== columns || $[1] !== desktopColumnCount || $[2] !== selectionPath) {
    const columnCount = resolveColumnCount(desktopColumnCount, columns);
    const style = {
      "--links-columns-count": columnCount
    } as CSSProperties;
    let t2;
    if ($[4] !== columns || $[5] !== selectionPath) {
      t2 = (_, columnIndex) => <div key={columnIndex} className="links-columns__column">{(columns[columnIndex] ?? []).map((group, groupIndex) => <LinksColumnsGroup key={`${columnIndex}-${groupIndex}-${group.title}`} group={group} selectionPath={selectionPath} />)}</div>;
      $[4] = columns;
      $[5] = selectionPath;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = <div className="links-columns" style={style}>{Array.from({
        length: columnCount
      }, t2)}</div>;
    $[0] = columns;
    $[1] = desktopColumnCount;
    $[2] = selectionPath;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
type LinksColumnsGroupProps = {
  group: NavigationGroupModel;
  selectionPath: string[];
};
function LinksColumnsGroup(t0) {
  const $ = _c(32);
  const {
    group,
    selectionPath
  } = t0;
  const titleId = useId();
  let t1;
  if ($[0] !== group.title || $[1] !== selectionPath) {
    t1 = [...selectionPath, group.title];
    $[0] = group.title;
    $[1] = selectionPath;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const groupPath = t1;
  const overviewLink = group.overviewLink;
  const handleServicesLinkClick = useServicesLinkClick();
  let t2;
  if ($[3] !== handleServicesLinkClick) {
    t2 = function handleLinkClick(event, href, selection, openInNewTab) {
      trackNavigationHeaderClick({
        selection,
        linkUrl: href,
        navSection: "main nav"
      });
      handleServicesLinkClick({
        event,
        link: href,
        shouldOpenInNewTab: openInNewTab
      });
    };
    $[3] = handleServicesLinkClick;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleLinkClick = t2;
  let t3;
  if ($[5] !== group.title || $[6] !== group.titleHref || $[7] !== groupPath || $[8] !== handleLinkClick) {
    t3 = group.titleHref ? <TextLink href={group.titleHref} onClick={event_0 => {
      if (group.titleHref) {
        handleLinkClick(event_0, group.titleHref, groupPath);
      }
    }}>{group.title}</TextLink> : group.title;
    $[5] = group.title;
    $[6] = group.titleHref;
    $[7] = groupPath;
    $[8] = handleLinkClick;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t3 || $[11] !== titleId) {
    t4 = <h3 id={titleId} className="links-columns__group-title sparky-u-theme-typography-body-bold">{t3}</h3>;
    $[10] = t3;
    $[11] = titleId;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== group.links || $[14] !== groupPath || $[15] !== handleLinkClick) {
    let t6;
    if ($[17] !== groupPath || $[18] !== handleLinkClick) {
      t6 = link => <li key={`${link.href}::${link.label}`} className="links-columns__group-link-item"><TextLink href={link.href} variant="secondary" rel={link.openInNewTab ? "noopener noreferrer" : undefined} target={link.openInNewTab ? "_blank" : undefined} onClick={event_1 => handleLinkClick(event_1, link.href, [...groupPath, link.label], link.openInNewTab)}>{link.label}</TextLink></li>;
      $[17] = groupPath;
      $[18] = handleLinkClick;
      $[19] = t6;
    } else {
      t6 = $[19];
    }
    t5 = group.links.map(t6);
    $[13] = group.links;
    $[14] = groupPath;
    $[15] = handleLinkClick;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[20] !== group.overviewLink?.openInNewTab || $[21] !== groupPath || $[22] !== handleLinkClick || $[23] !== overviewLink) {
    t6 = overviewLink && <li className="links-columns__group-link-item"><TextLink href={overviewLink.href} rel={group.overviewLink?.openInNewTab ? "noopener noreferrer" : undefined} target={group.overviewLink?.openInNewTab ? "_blank" : undefined} onClick={event_2 => handleLinkClick(event_2, overviewLink.href, [...groupPath, overviewLink.label], overviewLink.openInNewTab)}>{overviewLink.label}</TextLink></li>;
    $[20] = group.overviewLink?.openInNewTab;
    $[21] = groupPath;
    $[22] = handleLinkClick;
    $[23] = overviewLink;
    $[24] = t6;
  } else {
    t6 = $[24];
  }
  let t7;
  if ($[25] !== t5 || $[26] !== t6 || $[27] !== titleId) {
    t7 = <ul aria-labelledby={titleId} className="links-columns__group-links">{t5}{t6}</ul>;
    $[25] = t5;
    $[26] = t6;
    $[27] = titleId;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  let t8;
  if ($[29] !== t4 || $[30] !== t7) {
    t8 = <section className="links-columns__group">{t4}{t7}</section>;
    $[29] = t4;
    $[30] = t7;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  return t8;
}